import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'SunMoonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-moon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9.173 14.83a4 4 0 1 1 5.657 -5.657"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11.294 12.707l.174 .247a7.5 7.5 0 0 0 8.845 2.492a9 9 0 0 1 -14.671 2.914"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3v1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5.6 5.6l.7 .7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 21l18 -18"
    }, null), _createTextVNode(" ")]);
  }
};